import { supportedLocales } from './i18n'

export default {
  debug: true,
  state: {
    selectedLang: 'en',
    showRegionSelect: false,
    choosedRegion: null,
    // auth: {
    //   eu: null,
    //   ru: null,
    //   cn: null,
    // },
    auth: null,
  },
  isAuth() {
    return (
      this.choosedRegion
      && this.state.auth
      && this.state.auth.token
      && this.state.auth.expTokenJsTimestamp > Date.now()
    )
  },
  toggleRegionSelection() {
    console.log('toggleRegionSelection', this.state.showRegionSelect)
    this.state.showRegionSelect = !this.state.showRegionSelect
  },
  setRegion(region) {
    this.state.choosedRegion = region
    // localStorage.setItem('region', JSON.stringify(region))
    localStorage.setItem('region_code', region.code)
  },
  // setAuth(region, newValue) {
  //   if (this.debug) console.log('setAuth ', region, newValue)
  //   this.state.auth[region] = newValue
  // },
  setAuth(newValue) {
    this.state.auth = newValue
  },
  // clearAuth(region) {
  //   if (this.debug) console.log('clearAuth', region)
  //   this.state.auth[region] = null
  // },
  clearAuth() {
    this.state.auth = null
  },
  selectLang(langCode = null, vue) {
    console.log(this)
    if (langCode == null) {
      langCode = localStorage.getItem('locale')
      if (!langCode && this.$i18n && this.$i18n.locale) {
        langCode = this.$i18n.locale
      }
      // final fallback
      if (!langCode) langCode = 'en'
    }
    const lang = supportedLocales().find(l => l.code === langCode) || { code: 'en', title: 'English' }
    this.state.selectedLang = lang
    vue.$i18n.locale = lang.code
    localStorage.setItem('locale', lang.code)
  },
}
